import { render, staticRenderFns } from "./email-composer.vue?vue&type=template&id=20b6f0e2&scoped=true"
import script from "./email-composer.vue?vue&type=script&lang=js"
export * from "./email-composer.vue?vue&type=script&lang=js"
import style0 from "./email-composer.vue?vue&type=style&index=0&id=20b6f0e2&prod&lang=scss&scoped=true"
import style1 from "./email-composer.vue?vue&type=style&index=1&id=20b6f0e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b6f0e2",
  null
  
)

export default component.exports